export const INDIAN_MOBILE_LENGTH = 10;
export const AADHAAR_LENGTH = 12;

/** Strip non-digits and cap at 10 (Indian mobile without country code). */
export function sanitizeMobileDigits(value) {
  return String(value || "").replace(/\D/g, "").slice(0, INDIAN_MOBILE_LENGTH);
}

/** Strip non-digits and cap at 12 (Aadhaar). */
export function sanitizeAadhaarDigits(value) {
  return String(value || "").replace(/\D/g, "").slice(0, AADHAAR_LENGTH);
}

/** Normalize to 10-digit mobile; accepts leading 91 country code. */
export function normalizeIndianMobile(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === INDIAN_MOBILE_LENGTH) return digits;
  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  return "";
}

export function isValidIndianMobile(value) {
  return normalizeIndianMobile(value).length === INDIAN_MOBILE_LENGTH;
}

export function isValidAadhaarNumber(value) {
  return /^\d{12}$/.test(sanitizeAadhaarDigits(value));
}

/**
 * Login ID field: numeric entry → 10-digit mobile; otherwise allow short admin username.
 */
export function sanitizeLoginIdInput(value) {
  const raw = String(value || "");
  if (!raw) return "";
  if (/^[\d\s+\-()]*$/.test(raw.trim())) {
    return sanitizeMobileDigits(raw);
  }
  return raw.trim().slice(0, 64);
}
